(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .controller('UsersController', UsersController);

    UsersController.$inject = ['$rootScope', '$scope', '$state', '$stateParams', '$translate', '$uibModal', 'UsersService', 'UtilService', 'AlertService', 'API_URL'];

    function UsersController($rootScope, $scope, $state, $stateParams, $translate, $uibModal, UsersService, UtilService, AlertService, API_URL) {
        var vm = this;
        vm.translate = $translate.instant;

        /*Declare variables*/
        vm.filter = {
            data: {
                size: 25,
                page: 0,
                email: "",
                clientNumber: "",
                clientName: ""
            },
            clear: function() {
                vm.filter.data.email = "";
                vm.filter.data.clientNumber = "";
                vm.filter.data.clientName = "";
            },
            save: function() {
                if (vm.data && vm.data.page)
                    vm.filter.data.page = vm.data.page.number;
                $state.transitionTo($state.current, vm.filter.data, {
                    location: true,
                    inherit: true,
                    notify: false
                });
            },
            read: function() {
                angular.copy($stateParams, vm.filter.data);
            }
        };

        vm.data = null;

        /*Declare functions*/
        //Controller init
        vm.init = function() {
            vm.filter.read();
            if (UtilService.isFilled(vm.filter.data))
                vm.list.current();
        };

        //Getting users
        vm.list = {
            //List users
            current: function() {
                vm.filter.data.page = 0;
                UsersService.listWithParams(vm.filter.data)
                    .then(vm.list.then);
            },
            //Go to the first page
            first: function() {
                UtilService.get(vm.data, 'first', null, null)
                    .then(vm.list.then);
            },
            //Go to the previous page
            previous: function() {
                UtilService.get(vm.data, 'prev', null, null)
                    .then(vm.list.then);
            },
            //Go to the next page
            next: function() {
                UtilService.get(vm.data, 'next', null, null)
                    .then(vm.list.then);
            },
            //Go to the last page
            last: function() {
                UtilService.get(vm.data, 'last', null, null)
                    .then(vm.list.then);
            },
            then: function(response) {
                
                //add 'BENELUXUI' to url if missing 
                if(response.data._links['first'])
                    response.data._links['first'].href = fixURL(response.data._links['first'].href);
                if(response.data._links['self'])
                    response.data._links['self'].href = fixURL(response.data._links['self'].href);
                if(response.data._links['next'])
                    response.data._links['next'].href = fixURL(response.data._links['next'].href);
                if(response.data._links['prev'])
                    response.data._links['prev'].href = fixURL(response.data._links['prev'].href);
                if(response.data._links['last'])
                    response.data._links['last'].href = fixURL(response.data._links['last'].href);

                //Set data to controller data
                vm.data = response.data;
                if (response.data._embedded == null) {
                    AlertService.error($translate.instant('users.users.noUsersFound'));
                } else {
                    AlertService.clear();
                }
                //Write state to URL
                vm.filter.save();
            }
        };

        function fixURL(url) {
            if( url != null && !(url.indexOf('BENELUXUI') !== -1) && (url.indexOf('dev') !== -1 )) {
                return url.replace('edistrada2', 'BENELUXUI/edistrada2');
            }else {
                return url;
            }
        }

        //Managing user
        vm.user = {
            form: function() {
                var newUserModal = $uibModal.open({
                    templateUrl: 'app/views/users/newUser/newUser.html',
                    controller: 'NewUserController',
                    controllerAs: 'vm',
                    size: 'md'
                });

                newUserModal.result.then(function(newUser) {
                    UsersService.create(newUser)
                        .then(function() {
                            vm.list.current();
                            AlertService.success($translate.instant("users.newUser.userCreated"));
                        })
                        .catch(function() {
                            AlertService.error($translate.instant("error.occurred"));
                        });
                });
            }
        };

        //Navigating
        vm.nav = {
            user: function(user) {
                $state.go('user', user);
            }
        };

        //Generating report
        vm.report = {
            form: function() {
                var reportModal = $uibModal.open({
                    templateUrl: 'app/views/users/report/userReport.html',
                    controller: 'UserReportController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        filter: angular.copy(vm.filter.data)
                    }
                });

                reportModal.result.then(function(result) {});
            }
        };

        //Init controller
        vm.init();

        //Position fix-table
        var fixed = $('#fixed'),
            underFixed = $('#under-fixed');
        $scope.$watch(
            function() {
                return fixed.outerHeight();
            },
            function(newValue) {
                underFixed.css('padding-top', newValue);
            });
    }
})();
